import * as React from "react";
import { AuthPageLayout, AuthPageFooter } from "../../../../ui/components/AuthPageLayout";
import { DarkModeToggle } from "../../DarkModeToggle";
import { LanguageToggle } from "../../LanguageToggle";
import { getAuthPresentation } from "../../../lib/auth/auth-presentation";

export function AuthLayout({ children }: { children: React.ReactNode }) {
  // Which background to show (default vs. e.g. certification) depends on
  // the pending redirect captured by requireGuest() on route entry — see
  // src/app/lib/auth/auth-presentation.ts. (Title/subtitle copy is picked
  // the same way, but lives on the page component itself — see login.tsx.)
  const { background } = getAuthPresentation();

  return (
    <>
      <LanguageToggle placement="fixed" />
      <DarkModeToggle />
      <AuthPageLayout footer={<AuthPageFooter />} background={background}>
        {children}
      </AuthPageLayout>
    </>
  );
}
